import { lazy, Suspense, useCallback } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { crmDenied, markCrmDenied } from '../lib/crmAccess';

const AgenciaCrm = lazy(() => import('./AgenciaCrm'));

// La pestaña «Agencias» abre el CRM. Quien no tiene acceso al CRM va al
// directorio de agencias, que le explica por qué (AgencyReferenceLayout).
export default function AgenciaCrmGate() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const uid = user?.uid;
  const onForbidden = useCallback(() => {
    markCrmDenied(uid);
    navigate('/agencias/consulta', { replace: true });
  }, [uid, navigate]);
  if (crmDenied(uid)) return <Navigate to="/agencias/consulta" replace />;
  return <Suspense fallback={null}><AgenciaCrm onForbidden={onForbidden} /></Suspense>;
}
